import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c1367b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "axero-widget tl-widget tl-widget-immersion-countdown"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "axero-widget-background",
  src: "/Content/icons/thought-icon-lanyard-watermark-white.png"
}, null, -1 /* HOISTED */))
const _hoisted_3 = {
  href: "https://thoughtleaders.com.au/commitment-agreement",
  title: "Commitment Agreement",
  target: "_blank"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "axero-widget-header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "May 2022 The School Intake is fast approaching!")
], -1 /* HOISTED */))
const _hoisted_5 = { class: "axero-widget-content" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You have", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.shouldShowAtAll)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("a", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (_ctx.shouldShowSecondCutoff)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Did you miss the first 'Welcome to TLBS\" Session on the " + _toDisplayString(_ctx.cutoffDateFormatted) + "? Don't worry we have few places left for late starters to sign up before 12am " + _toDisplayString(_ctx.secondCutoffDateFormatted) + ".", 1 /* TEXT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_7,
                  _createElementVNode("h2", null, _toDisplayString(_ctx.daysUntilCutoff) + " " + _toDisplayString(_ctx.dayStringPlural), 1 /* TEXT */),
                  _createElementVNode("p", null, "until intake closes on " + _toDisplayString(_ctx.cutoffDateFormatted) + ".", 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}